<template>
  <router-view/>
  <div class="goTop" id="goTop" @click="topPage()">
    <img src="images/icons/arrow_forward_dark.svg" alt="Ugrás az oldal tetejére!" >
  </div>

</template>

<script setup>
function topPage() {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}
</script>

<style>

.construction {
  position: fixed;
  bottom: 10px;
  left: 20px;
  z-index: 100;
  background-color: #f5f5f5;
  padding: 5px 10px;
  border-radius: 50px;
}

.goTop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 100;
  cursor: pointer;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  transition: 0.3s ease-in-out;
  background-color: #cecece;
}

.goTop img {
  width: 30px;
  height: 30px;
  transform: rotate(270deg);
  cursor: pointer;
}

.goTop:hover {
  transform: scale(1.1);
  transition: 0.3s ease-in-out;
}

@media screen and (max-width: 725px) {
  .goTop {
    display: none;
  }
}
</style>
